<template>
	<div class="report_container full" v-loading="loading">
		<el-container class="full">
			<el-header height="45px" class="head">
				<el-switch style="padding-left:20px" v-model="showUnsendwln" @change="showUnsendwlnChange" active-text="万里牛未同步" inactive-text=""></el-switch>
				<el-switch style="padding-left:20px" v-model="showUnsendjindie" @change="showUnsendjindieChange" active-text="星空未同步" inactive-text=""></el-switch>
				<el-switch style="padding-left:20px" v-model="showIgnore" @change="showIgnoreChange" active-text="显示忽略" inactive-text=""></el-switch>
			</el-header>
			<el-main class="main flex">
				<vxe-grid v-if="list_gridOptions" ref="flowothertreport" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>		
			</el-main>
		</el-container>
		<edit-index ref="rowedit" :row="currentrow" @success="success" />
		<importTable :ref="importRef" :moduleName="importModuleName" :importpredata="importpredata"  />
	</div>
</template>
<style>

</style>
<style scoped>
	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}
	
	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}
	
	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;
	
	}
	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>
<script>
	
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import editIndex from './lib/edit/index.vue'
	import importTable from '@_system/components/import/index.vue'
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {
			fundtype: {
				default: () => {
					return 'CD'
				}
			},
			bancktype: {
				default: () => {
					return ''
				}
			},			
		},
		data() {
			return {
				importpredata:[],
				importRef: Math.random(),
				importModuleName:null,
				currentrow:null,
				loading:false,
				showUnsendjindie:false,
				showUnsendwln:false,
				showIgnore:false,
				showtransferaccount:false,
				transTime: null,
				reportName: 'reconciliation_bankflow',
				foreingKey:{},
				list_formConfig: [{
					field: 'accName',
					title: '户名',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'bankAcc',
					title: '账号',
					span: 4,
					itemRender: {
						name: '$select',
						props:{
							cascader:true,
							emptyoption:false,
							multiple:true,
							filterable:true
							
						}
					}
				},{
					field: 'serialId',
					title: '流水ID',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'custommark',
					title: '自定义备注',
					span: 4,
					itemRender: {
						name: '$input',
						props:{}
					}
				},{
					field: 'cdSign',
					title: '收支方向',
					span: 4,
					resetValue:'-1',
					itemRender: {
						defaultValue:'-1',
						name: '$select',
						props:{							
							emptyoption:false,
							selectoptions:[{
								value:'-1',
								label:'全部'
							},{
								value:'0',
								label:'收入'
							},{
								value:'1',
								label:'支出'
							}]
						}
					}
				},{
					field: 'transTime',
					title: '时间',
					span: 4,
					itemRender: {
						name: '$datePicker',
						props:{}
					}
				}]
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			//this.$refs[this.importRef].importcomfig = this.importcomfig
		},
		computed: {

		},
		methods: {

			// list_beforeCreateGrid(list_gridOptions){
			// 	return Promise((reslove)=>{
			// 		this.$api.reconciliation_bankflow.getbankacc().then((res) => {
			// 			console.log(list_gridOptions,res)	
			// 			reslove()
			// 		})
			// 	})
			// },
			list(page,updateForm,other) {
				return new Promise(resolve => {
					//console.log(updateForm,12312312)
					this.$api.report.reportlist(this.reportName,{
						...page,
						...updateForm,
						...other,
						...this.foreingKey,
						...{
							fundtype:this.fundtype,
							bancktype:this.bancktype,
						}
					}).then((res) => {
						this.sourcedata = JSON.parse(JSON.stringify(res.list))
						if (this.afterGet) {
							this.afterGet(res,updateForm)
						}
						resolve(res)
					}, () => {
						resolve([])
					})
				})
			},
			showUnsendwlnChange(e){
				this.foreingKey.showUnsendwln = e?1:0
				this.customreload()
			},
			showtransferaccountChange(e){
				this.foreingKey.showtransferaccount = e?1:0
				this.customreload()
			},
			showUnsendjindieChange(e){
				this.foreingKey.unsendjindie = e?1:0
				this.customreload()
			},			
			showIgnoreChange(e){
				this.foreingKey.ignore = e?1:0
				this.customreload()
			},
			list_beforeCreateGrid(gridOptions){
				return new Promise((reslove)=>{
					this.$api.reconciliation_bankflow.getbankacc().then((res) => {
						this.list_formConfig.forEach((item)=>{
							if(item.field == 'bankAcc'){
								let selectoptions = []
								for(let i in res){
									selectoptions.push({
										value:i,
										label:i,
										children:res[i].map((option)=>{
											return {
												value:option.bankAcc,
												label:option.bankAcc + '【'+option.accName+'】'
											}
										})
									})
								}
								item.itemRender.props.selectoptions = selectoptions
							}
						})
						gridOptions.id = 'otherreport_list'
						gridOptions.pagerConfig.enabled = true
						gridOptions.columns = [			
							{type:'checkbox',title:'#',fixed:'left',width:50},
							{field:'serialNo',title:'单据编码',render:'$input',props:{show:true},fixed:'left',width:'auto'},
							{field:'accName',title:'户名',render:'$input',props:{show:true},width:'auto'},
							{field:'bankAcc',title:'账号',render:'$input',props:{show:true},width:'auto'},
							{
								field:'transTime',
								title:'时间',
								render:'$datePicker',
								formatter:({cellValue})=>{
									return window.systemMethods.timestampToDate(cellValue)
								},
								props:{show:true},
								width:'auto',
							},
							{field:'amt',title:'交易金额',render:'',props:{show:true},width:100},
							{field:'bal',title:'余额',render:'',props:{show:true},width:100},
							{field:'oppAccName',title:'对方户名',render:'',props:{show:true},width:'auto'},
							{field:'oppAccNo',title:'对方账号',render:'',props:{show:true},width:'auto'},		
							{field:'serialId',title:'流水ID',render:'',props:{show:true},fixed:'right',width:200},
							{field:'relationtype',title:'关联方式',render:'',props:{show:true},fixed:'right',
								formatter:({cellValue})=>{
									return cellValue == 1?'自动':'手动'
								},width:100},
								
							{
								field:'ignore',
								title:'忽略',
								render:'',
								cellRender:{
									name:'$switch',
									enabled:true,
									props:{
										openLabel:'是',
										closeLabel:'否',
										openValue:1,
										closeValue:0,
										size:'medium',
									},
									events:{
										change:({row})=>{
											this.ignoreChnage(row)
										}
									}
								},
								props:{show:true},
								width:100,
								fixed:'right',
							},	
								
								
							{field:'custommark',title:'自定义备注',render:'',props:{show:true},fixed:'right',width:100},							
							{field:'export_wln',title:'万里牛',render:'',props:{show:true},fixed:'right',width:100},
							{
								title: '操作',
								fixed: "right",
								align: 'center',
								width: 120,
								slots: {
									default: ({row}) => {
										return [
											<el-button style="color:#67C23A" type = "text" size = "mini" onClick = {() => {this.custommark(row)}}>备注</el-button>,
											<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>,
											// <vxe-button type="text" transfer>
											// 	<template slot="default">单据</template>
											// 	<template slot="dropdowns">
											// 		<vxe-button mode = "text" size = "mini" onClick = {() => {this.createcostorder(row)}}>费用单</vxe-button>
											// 		<vxe-button mode = "text" size = "mini" onClick = {() => {this.createtransferaccounts(row)}}>转账单</vxe-button>
											// 		<vxe-button mode = "text" size = "mini" onClick = {() => {this.demo(row)}}>客户收款认领</vxe-button>
											// 		<vxe-button mode = "text" size = "mini" onClick = {() => {this.demo(row)}}>供应商退款认领</vxe-button>
											// 	</template>
											// </vxe-button>
										]
									}
								}
							}
						]
						gridOptions.checkboxConfig = null
						
						gridOptions.toolbarConfig.buttons = [{
							name: '导出',
							status: 'success',
							code: 'export'
						},{
							name: '同步万里牛',
							status: 'success',
							code: 'sendwln'
						},{
							name: '转费用',
							status: '',
							code: 'batch2costorder'
						},{
							name: '转转账',
							status: '',
							code: 'batch2transferaccounts'
						},{
							name: '转收款',
							status: '',
							code: 'batch2collection'
						}]
						gridOptions.columns.forEach((item)=>{
							if(item.field=='serialNo'){
								item.slots = {
									default: ({row}) => {	
										let str= []
										if(row.cdSign==1){
											str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">支</el-tag>)
										}
										if(row.cdSign==0){
											str.push(<el-tag size="mini" type="success" effect="dark" style="margin-right: 2px;">收</el-tag>)
										}
										str.push(<span>{row.serialNo}</span>)
										return str
									}
								}
							}
							if(item.field=='export_wln'){
								item.slots = {
									default:({row})=>{
										if(!row.export_wln){
											if(row.export_wln_error){
												return <span style="color:#F56C6C;">{row.export_wln_error}</span> 
											}else{
												return <span style="color:#F56C6C;">未同步</span> 							
											}	
										}else{
											return <span>{row.export_wln}</span> 	
										}
									}
								}
							}
						})
						
						
						
						
						reslove()
					})
				})
			},
			ignoreChnage(row){
				this.$api.reconciliation_bankflow.updateignore({
					id:row.id,
					ignore:row.ignore
				}).then(() => {
					this.$message.success('操作成功')
				})
			},
			showstream(row){
				this.streamdata = row.stream
				this.$refs.skstream.modal_show()
			},
			sendjindie(){
				let data =  this.$refs.flowothertreport.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}				
				data.forEach((item)=>{
					this.loading = true
					this.$api.reconciliation_bankflow.sendjindie({id:item.id}).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				})
			},
			sendwln(){
				let data =  this.$refs.flowothertreport.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}				
				data.forEach((item)=>{
					this.loading = true
					this.$api.reconciliation_bankflow.sendwln({
							serialNo:item.serialNo,
						}).then(()=>{
						this.loading = false
						this.customreload()
					},()=>{
						this.loading = false
					})
				})				
			},
			createcostorder(row){
				if(!Array.isArray(row)){
					row = [row]
				}
				this.importpredata = row.map((item)=>{
					let company = window.systemData.company.find((_item)=>{
						return _item.name == item.accName
					})
					return {
						'main|bankAcc':item.bankAcc,
						'main|rcvAcc':item.oppAccNo,
						'main|serialId':item.serialId,
						'main|paymenttime':item.transTime,
						'main|biztime':item.transTime,
						'main|companyid':company?company.id:null,
						'costorder_detail|businessdepartmentid':null,
						'costorder_detail|costamount':item.cdSign == 0 ? -item.amt : item.amt
					}
				})
				this.importModuleName = 'costorder'
				this.$refs[this.importRef].importpanel()
			},
			createtransferaccounts(row){
				if(!Array.isArray(row)){
					row = [row]
				}
				this.importpredata = row.map((item)=>{
					if(item.cdSign==1){
						return {
							'main|payAcc':item.bankAcc,
							'main|rcvAcc':item.oppAccNo,
							'main|serialId':item.serialId,
							'main|amount':item.amt							
						}
					}else{
						return	{
							'main|payAcc':item.oppAccNo,
							'main|rcvAcc':item.bankAcc,
							'main|rcvserialId':item.serialId,
							'main|amount':item.amt
							
						}
					}
				})
				this.importModuleName = 'transferaccounts'
				this.$refs[this.importRef].importpanel()
			},
			createcollection(row){
				if(!Array.isArray(row)){
					row = [row]
				}
				row.forEach((item)=>{
					if(item.cdSign==0){
						this.loading = true
						this.$api.reconciliation_bankflow.flow2collection({id:item.id}).then(()=>{
							this.loading = false
							this.customreload()
						},()=>{
							this.loading = false
						})
					}
				})	
			},
			batch2costorder(){
				let data =  this.$refs.flowothertreport.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}	
				this.createcostorder(data)
			},
			batch2transferaccounts(){
				let data =  this.$refs.flowothertreport.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}	
				this.createtransferaccounts(data)
			},
			batch2collection(){
				let data =  this.$refs.flowothertreport.getCheckboxRecords()
				if(!data.length){
					this.$message.error('请选择数据')
					return
				}
				
				this.createcollection(data)
			},
			
			
			// importcomfig() {
				
			// },
			// importcostordercomfig(){
			// 	return new Promise((reslove)=>{
			// 		this.$api.module.moduleImporttemplate(window.config.app, 'costorder').then((res) => {
			// 			reslove(res)
			// 		})
			// 	})
			// },
			// importtransferaccountscomfig(){
			// 	return new Promise((reslove)=>{
			// 		this.$api.module.moduleImporttemplate(window.config.app, 'transferaccounts').then((res) => {
			// 			reslove(res)
			// 		})
			// 	})
			// },			
			receipt(row) {
				this.param = {code:row.paymentapplicationcode}
				this.$nextTick(()=>{
					this.$refs.receiptBox.modalShow()
				})
				// this.currentrow = row
				// let handle = this.$loading()
				// this.$api.paymentapplication.getReceiptInfo({
				// 	supplierwlnid: row.purchasesupplierid,
				// 	id: row.paymentapplicationid,
				// 	type: row.ordertype
				// }).then((res) => {
				// 	this.receiptInfo = res
				// 	this.receiptType = row.ordertype
				// 	this.$loadingclose(handle)
				// 	this.$refs.receiptBox.modalShow()

				// },()=>{
				// 	this.$loadingclose(handle)
				// })
				
			},
			settlement(row) {
				let handle = this.$loading()
				this.$api.reconciliationcurrent.settlement({
					id: row.id,
					wlnid: row.purchasesupplierid,
					purchasecode: row.serialNo
				}).then(() => {
					this.$loadingclose(handle)
					this.$message.success('操作成功')
					this.customreload()

				}, () => {
					this.$loadingclose(handle)
				})
				console.log(row)
			},
			cellStyle({
				row,
				column
			}) {
				if (column.property && column.property.indexOf('haspaper') !== -1) {
					if (row.haspaper == 6) {
						return {
							color: '#F56C6C'
						}
					}
					if (row.haspaper == 5) {
						return {
							color: '#67C23A'
						}
					}
				}
			},
			paymentsummary() {
				let form = this.$refs.flowothertreport.getProxyInfo().form
				this.transTime = form.transTime
				this.$refs.statistics.modal_show()
			},
			custommark(row){
				this.$prompt('请输入内容【'+row.serialNo+'】','提示').then(({ value })=>{
					this.$api.reconciliation_bankflow.custommark({
						fundtype:this.fundtype,
						bancktype:this.bancktype,
						custommark:value,
						id:row.id
					}).then(() => {
						row.custommark = value
					})
				})
			},
			edit(row){
				this.currentrow = row
				this.$refs.rowedit.modalShow()
			},
			success(){
				this.customreload()
			},
			customreload(){
				if(this.$refs.flowothertreport){
					this.$refs.flowothertreport.commitProxy('query')
				}
				
			},
			exportdetail(e){
				let obj = {}
				obj.data = e.data
				obj.columns = this.$refs.flowothertreport.getColumns()
				this.$refs[this.exportRef].exportData(obj)
			}
		},
		components: {
			editIndex,
			importTable
			// exportTable,
			// receiptIndex,
			// statisticsIndex,
			// editIndex
		}
	}
</script>